import { useState, useMemo } from "react";
import ImagePreviewModal from "./ImagePreviewModal";

export default function ImageUpload({
  label,
  value,
  onChange,
  error,
  required,
}) {
  const [openPreview, setOpenPreview] = useState(false);

  const previewUrl = useMemo(() => {
    if (value instanceof File) {
      return URL.createObjectURL(value);
    }
    if (typeof value === "string") {
      return value;
    }
    return null;
  }, [value]);

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium text-slate-700">
        {label} {required && <span className="text-red-500">*</span>}
      </label>

      {/* CAMERA-FIRST INPUT */}
      <div className="relative border-2 border-dashed rounded-lg p-3 text-center hover:border-blue-500 transition">
        <input
          type="file"
          accept="image/*"
          capture="environment"
          className="hidden"
          id={label}
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (!file) return;
            onChange(file);
          }}
        />

        <label
          htmlFor={label}
          className="cursor-pointer text-xs font-medium text-blue-600 hover:underline"
        >
          {value ? "Retake Photo" : "Click Photo"}
        </label>
      </div>

      {/* PREVIEW */}
      {previewUrl && (
        <div className="border rounded-lg p-2">
          <img
            src={previewUrl}
            alt={label}
            className="h-32 w-full object-contain rounded cursor-zoom-in"
            onClick={() => setOpenPreview(true)}
          />
          <p className="text-[10px] text-center text-slate-400 mt-1">
            Tap image to preview
          </p>
        </div>
      )}

      {error && <p className="text-xs text-red-500">{error}</p>}

      <ImagePreviewModal
        open={openPreview}
        imageUrl={previewUrl || ""}
        onClose={() => setOpenPreview(false)}
      />
    </div>
  );
}




// import { useState } from "react";
// import ImagePreviewModal from "./ImagePreviewModal";

// export default function ImageUpload({
//   label,
//   value,
//   onChange,
//   error,
//   required,
// }) {
//   const [openPreview, setOpenPreview] = useState(false);

//   return (
//     <div className="space-y-2">
//       <label className="text-sm font-medium text-slate-700">
//         {label} {required && <span className="text-red-500">*</span>}
//       </label>

//       {/* CAMERA-FIRST INPUT */}
//       <div className="relative border-2 border-dashed rounded-lg p-3 text-center hover:border-blue-500 transition">
//         <input
//           type="file"
//           accept="image/*"
//           capture="environment"   // 🔥 THIS IS THE KEY
//           className="hidden"
//           id={label}
//           onChange={(e) => {
//             const file = e.target.files?.[0];
//             if (!file) return;
//             onChange(file);
//           }}
//         />

//         <label
//           htmlFor={label}
//           className="cursor-pointer text-xs font-medium text-blue-600 hover:underline"
//         >
//           {value ? "Retake Photo" : "Click Photo"}
//         </label>
//       </div>

//       {/* PREVIEW */}
//       {value && (
//         <div className="border rounded-lg p-2">
//           <img
//             src={URL.createObjectURL(value)}
//             alt={label}
//             className="h-32 w-full object-contain rounded cursor-zoom-in"
//             onClick={() => setOpenPreview(true)}
//           />
//           <p className="text-[10px] text-center text-slate-400 mt-1">
//             Tap image to preview
//           </p>
//         </div>
//       )}

//       {error && (
//         <p className="text-xs text-red-500">{error}</p>
//       )}

//       <ImagePreviewModal
//         open={openPreview}
//         imageUrl={value ? URL.createObjectURL(value) : ""}
//         onClose={() => setOpenPreview(false)}
//       />
//     </div>
//   );
// }



// import { useState } from "react";
// import ImagePreviewModal from "./ImagePreviewModal";

// export default function ImageUpload({
//   label,
//   value,
//   onChange,
//   error,
//   required,
// }) {
//   const [openPreview, setOpenPreview] = useState(false);

//   return (
//     <div className="space-y-2">
//       <label className="text-sm font-medium text-slate-700">
//         {label} {required && <span className="text-red-500">*</span>}
//       </label>

//       {/* UPLOAD / CHANGE BUTTON */}
//       <div className="relative border-2 border-dashed rounded-lg p-3 text-center hover:border-blue-500 transition">
//         <input
//           type="file"
//           accept="image/*"
//           className="hidden"
//           id={label}
//           onChange={(e) => onChange(e.target.files[0])}
//         />

//         <label
//           htmlFor={label}
//           className="cursor-pointer text-xs font-medium text-blue-600 hover:underline"
//         >
//           {value ? "Change image" : "Choose image"}
//         </label>
//       </div>

//       {/* IMAGE PREVIEW (BELOW) */}
//       {value && (
//         <div className="border rounded-lg p-2">
//           <img
//             src={value}
//             alt={label}
//             className="h-32 w-full object-contain rounded cursor-zoom-in"
//             onClick={() => setOpenPreview(true)}
//           />
//           <p className="text-[10px] text-center text-slate-400 mt-1">
//             Click image to preview
//           </p>
//         </div>
//       )}

//       {error && (
//         <p className="text-xs text-red-500">
//           {error}
//         </p>
//       )}

//       {/* FULL IMAGE PREVIEW MODAL */}
//       <ImagePreviewModal
//         open={openPreview}
//         imageUrl={value}
//         onClose={() => setOpenPreview(false)}
//       />
//     </div>
//   );
// }
 

// import { useState } from "react";
// import ImagePreviewModal from "./ImagePreviewModal";


// export default function ImageUpload({
//   label,
//   value,
//   onChange,
//   error,
//   required,
// }) {
//   const [openPreview, setOpenPreview] = useState(false);

//   return (
//     <div className="space-y-1">
//       <label className="text-sm font-medium text-slate-700">
//         {label} {required && <span className="text-red-500">*</span>}
//       </label>

//       <div className="relative border-2 border-dashed rounded-lg p-3 text-center hover:border-blue-500 transition">
//         <input
//           type="file"
//           accept="image/*"
//           className="hidden"
//           id={label}
//           onChange={(e) => onChange(e.target.files[0])}
//         />

//         <label htmlFor={label} className="cursor-pointer block">
//           {value ? (
//             <img
//               src={value}
//               alt={label}
//               className="h-32 w-full object-contain rounded cursor-zoom-in"
//               onClick={(e) => {
//                 e.preventDefault();
//                 setOpenPreview(true);
//               }}
//             />
//           ) : (
//             <div className="text-xs text-slate-500">
//               Click to upload image
//             </div>
//           )}
//         </label>
//       </div>

//       {error && (
//         <p className="text-xs text-red-500">
//           {error}
//         </p>
//       )}

//       {/* 🔍 FULL IMAGE PREVIEW MODAL */}
//       <ImagePreviewModal
//         open={openPreview}
//         imageUrl={value}
//         onClose={() => setOpenPreview(false)}
//       />
//     </div>
//   );
// }

